import {FuseLoadable} from '@fuse';

export const InfrastructureConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/readypayonline/Infrastructure',
            component: FuseLoadable({
                loader: () => import('./Infrastructure')
            })
        },
      
       
      

    ]
};

